module.exports = __webpack_public_path__ + "media/images/people/girl-8-4df03d206c05dc8ebe40a10300e99200.webp";